import { 
    USER_ROLE_GET_REQUEST, USER_ROLE_GET_SUCCESS, USER_ROLE_GET_ERROR, 
    USER_ROLE_GET_BY_KEY_REQUEST, USER_ROLE_GET_BY_KEY_SUCCESS, USER_ROLE_GET_BY_KEY_ERROR, 
    USER_ROLE_ADD_REQUEST, USER_ROLE_ADD_SUCCESS, USER_ROLE_ADD_ERROR, 
    USER_ROLE_EDIT_REQUEST, USER_ROLE_EDIT_SUCCESS, USER_ROLE_EDIT_ERROR, 
    USER_ROLE_DELETE_REQUEST, USER_ROLE_DELETE_SUCCESS, USER_ROLE_DELETE_ERROR
} from "../constants/userRoleConstants";

const initialState = {
    userRoles: [],
    userRole: {},
    loading: false,
    success: null,
    error: null,
    userRoleRequestedCount: 0,
};

export const userRoleReducer = (state = initialState, action) => {
    switch (action.type)     {
        case USER_ROLE_GET_REQUEST:
            return {
                ...state,
                userRoleRequestedCount: ++state.userRoleRequestedCount,
                loading: true,
            };
        case USER_ROLE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                userRoles: action.payload,
                success: true,
            };
        case USER_ROLE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case USER_ROLE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case USER_ROLE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                userRole: action.payload,
                success: true,
            };
        case USER_ROLE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case USER_ROLE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case USER_ROLE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case USER_ROLE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case USER_ROLE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case USER_ROLE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case USER_ROLE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case USER_ROLE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case USER_ROLE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case USER_ROLE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
